import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import LayoutHome from "./LayoutHome";
import useCardInfo from "../hooks/useCardInfo";
import useNotiTab from "../hooks/useNotiTab";
import useRequest from "../hooks/useRequest";

function Home() {
  const { t } = useTranslation();
  const cardInfo = useCardInfo();
  const notiTab = useNotiTab();
  const request = useRequest();

  return (
    <MainLayout
      title={t("home.headerWelcome")}
      headerContent={cardInfo.getGreeting()}
    >
      <LayoutHome cardInfo={cardInfo} notiTab={notiTab} request={request} />
    </MainLayout>
  );
}

export default Home;